import React from 'react';
import Header from '../../Components/Header/Header.jsx';
import TrustBar from '../../Components/TrustBar/TrustBar.jsx';
import WhatWeBuild from '../../Components/WhatWeBuild/WhatWeBuild.jsx';
import AiAutomation from '../../Components/AiAutomation/AiAutomation.jsx';
import Projects from '../../Components/Projects/Projects.jsx';
import Score from '../../Components/Score/Score.jsx';
import Industries from '../../Components/Industries/Industries.jsx';
import TestimonialSection from '../../Components/testominal/TestimonialSection.jsx';
import GlobalCta from '../../Components/GlobalCta/GlobalCta.jsx';

const Home = () => {
  return (
    <div className="bg-white min-h-screen text-slate-900 font-sans selection:bg-[#f06600] selection:text-white w-full overflow-x-hidden">
      {/* 01. Hero Section (Dark Futuristic Agency with Developer Workspace) */}
      <Header />

      {/* 02. Trusted By Ambitious Businesses (Partner Logos Bar) */}
      <TrustBar />

      {/* 03. What We Do (Full-Service Digital Partner for Growing Businesses - 6 Service Cards) */}
      <WhatWeBuild />

      {/* 04. AI Showcase (Harness the Power of AI for Your Business - Robot Visual & Badges) */}
      <AiAutomation />

      {/* 05. Featured Work (Ideas Turned Into Real Results - Top 3 Projects on Home) */}
      <Projects limit={3} isHomePage={true} />

      {/* 06. Key Metrics & Numbers (100+ Happy Clients, 250+ Projects, 5+ Years, 99% Satisfaction) */}
      <Score />

      {/* 07. Industries We Serve (Building Digital Solutions Across Every Industry - 6 Photo Cards) */}
      <Industries />

      {/* 08. Client Testimonials (Trusted by Businesses That Believe in Growth - Ahmed Raza) */}
      <TestimonialSection />

      {/* 09. Final Call to Action (Ready to Grow Your Business Digitally? Orange Gradient Banner) */}
      <GlobalCta />
    </div>  
  );
};

export default Home;
